import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { getFirestore } from 'firebase/firestore';
import firebaseConfig from './firebase.config';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const CoreContext = React.createContext({});

const CoreContextProvider = ({ children }) => {
  let firebase, auth, firestore;
  try {
    firebase = initializeApp(firebaseConfig);
    auth = getAuth(firebase);
    firestore = getFirestore(firebase);
  } catch (err) {
    console.log(
      20001,
      'Failed to Initialize Application. Error : ' + err.message + err.stack
    );
  }

  const coreValues = {
    firebase,
    firestore,
    auth,
  };
  return (
    <CoreContext.Provider value={coreValues}>{children}</CoreContext.Provider>
  );
};

export const useCore = () => {
  return useContext(CoreContext);
};

CoreContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { CoreContextProvider };
